import PropTypes from 'prop-types';

const paymentMethodPropTypes = PropTypes.shape({
  last4: PropTypes.string,
  type: PropTypes.oneOf([
    'BANK_ACCOUNT',
    'CREDIT_CARD',
    'CARD',
    'PREPAID',
    'DEBIT_CARD',
  ]),
  id: PropTypes.string,
  is_default: PropTypes.bool,
  used_for_rent_payments: PropTypes.bool,
  expiration: PropTypes.string,
  brand: PropTypes.string,
  source_status: PropTypes.oneOf([
    'NEW',
    'VALIDATED',
    'VERIFIED',
    'VERIFICATION_FAILED',
    'ERRORED',
    'LOGIN_EXPIRED',
  ]),
  source_creation: PropTypes.string,
  preferred_for_rent_payments: PropTypes.bool,
  preferred_for_auto_pay: PropTypes.bool,
});
export default paymentMethodPropTypes;
